import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aqjro3p2: FaireBrandEntity = {
  token: "b_aqjro3p2",
  type: "brand",
  name: "ROEN",
  avatarUrl:
    "https://cdn.faire.com/fastly/63b4dc83e092933bc86f0d91773f34fad74a317b004d75ae247c2d920aa668bf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/23e24ea9d635f04dabc8a71c9ff23170389d939d0edbee196501af42e8820334.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/63b4dc83e092933bc86f0d91773f34fad74a317b004d75ae247c2d920aa668bf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/23e24ea9d635f04dabc8a71c9ff23170389d939d0edbee196501af42e8820334.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 107,
  isInsider: true,
  description:
    "R O E N candles was created by Brit Roennigke in Los Angeles. After having her second child, Brit made the decision to leave a career in fashion merchandising to pursue her true dream - to create a product and build a brand of her own. On a quest to capture the intoxicating spring scent of citrus blossom and jasmine in her Los Angeles neighborhood of Glassell Park, R O E N was born.  What began as a labor of love quickly evolved into a true passion and eventually, a small business. By drawing inspiration from her past experience in Fashion, Styling, and Product Development she has created a thoughtfully designed and irresistibly scented collection. Each candle is lovingly handcrafted in her petite L.A. bungalow using a small batch approach with the utmost focus on precision and care. The product aesthetic is minimalist and clean and will make a beautiful addition to any home.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:19.049Z",
    importedBy: "entity-db-cli",
  },
};
